export default __webpack_public_path__ + "static/media/tatianemodena-1-1920x1080Tiny.efd464fe.png";